import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./master-create-study.module.scss";
import { Outlet, useNavigate } from "react-router-dom";
import close from "../../../images/master-plan-close.svg";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { resetStudyCreationState } from "../../../services/reducers/master-create-study";
import CloseMasterCreateStudyModal from "./close-master-create-study-modal/close-master-create-study-modal";

const MasterCreateStudy = () => {
  const [isOpenCloseModal, setIsOpenCloseModal] = useState<boolean>(false);

  const { t } = useTranslation();
  const todayDate = new Date();
  const formattedDate = todayDate.toLocaleDateString("en-GB");
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    return () => {
      dispatch(resetStudyCreationState());
    };
  }, []);

  const handleOpenCloseMasterModal = () => {
    setIsOpenCloseModal(true);
  };

  const handleCloseMasterModal = () => {
    setIsOpenCloseModal(false);
  };

  const handleCloseMaster = () => {
    navigate("/repository/reports");
  };

  return (
    <div className={styles.masterCreateStudy}>
      <div className={styles.header}>
        <span className={styles.title}>{t("master-create-study.title")}</span>
        <p className={styles.curDate}>
          {t("master-create-study.datePrefix")}
          {formattedDate}
        </p>
        <button
          className={styles.closeBtn}
          onClick={handleOpenCloseMasterModal}
        >
          <img src={close} alt={t("master-create-study.closeAlt")} />
        </button>
      </div>
      <div className={styles.content}>
        <Outlet />
      </div>

      {isOpenCloseModal && (
        <CloseMasterCreateStudyModal
          onReturn={handleCloseMasterModal}
          onConfirm={handleCloseMaster}
        />
      )}
    </div>
  );
};

export default MasterCreateStudy;
